import React from "react";

import cx from "classnames";

import styles from "./Toggle.module.css";

type ToggleProps = {
	checked: boolean | undefined;
	onChange: (value: boolean) => void;
};

export default function Toggle({ checked, onChange }: ToggleProps) {
	function handleClick(checked: boolean) {
		return () => onChange(checked);
	}

	return (
		<div className={cx(styles.toggle, { [styles.checked]: checked })}>
			<div className={cx(styles.toggleChoice, styles.no)} onClick={handleClick(false)}>
				No
			</div>

			<div className={cx(styles.toggleChoice, styles.yes)} onClick={handleClick(true)}>
				Yes
			</div>
		</div>
	);
}
